
import { defineComponent, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['resetted', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            bin: null as string | null,
            companyShortName: null as string | null,
            email: null as string | null,
            createdAt: null as string | null,
        })

        const reset = () => {
            if (props.loading) return

            state.bin = null
            state.companyShortName = null
            state.email = null
            state.createdAt = null

            emit('resetted')
        }

        const search = () => {
            if (props.loading) return

            emit('search', {
                bin: state.bin,
                companyShortName: state.companyShortName,
                email: state.email,
                createdAt: state.createdAt,
            })
        }

        return {
            state,
            reset,
            search,
        }
    },
})
